import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import BlogDetail from '@/components/screens/blog-detail/BlogDetail';
import { API_URL } from '@/helpers/variables';
import { IBlogDetail } from '@/interfaces/blogDetail.interface';
import { IBlogBooks } from '@/interfaces/blogBooks.interface';

interface IBlogPageDynamicProps {
  blog: IBlogDetail;
  blogBooks: IBlogBooks;
}

const BlogPageDynamic: NextPage<IBlogPageDynamicProps> = ({ blog, blogBooks }) => {
  return <BlogDetail blog={blog} books={blogBooks} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const [blogRes, blogBooksRes] = await Promise.all([fetch(`${API_URL}satellite/posts/${alias}`), fetch(`${API_URL}satellite/posts/books/related/${alias}`)]);

  const [blog, blogBooks] = await Promise.all([blogRes.json(), blogBooksRes.json()]);

  return { props: { blog, blogBooks } };
};

export default BlogPageDynamic;
